import type { Office as OfficeType } from "@gql";

import * as styles from "./Office.styles";

interface Props {
  office: Pick<
    OfficeType,
    "addressLine1" | "city" | "province" | "postalCode" | "website" | "name" | "telephone"
  >;
}

const Office = ({ office }: Props) => {
  const renderAddress = () => {
    if (!office.addressLine1 || !office.city || !office.province || !office.postalCode) {
      return null;
    }

    return (
      <address css={styles.address}>
        {office.addressLine1}
        <br />
        {office.city}, {office.province}
        <br />
        {office.postalCode}
      </address>
    );
  };

  const renderWebsiteLink = () => {
    if (!office.website) return null;
    return <a href={office.website}>{office.website}</a>;
  };

  return (
    <div data-testid="office" css={styles.office}>
      <h2 css={styles.header}>
        <a href={office.website}>{office.name}</a>
      </h2>
      {renderAddress()}
      <ul css={styles.officeDetails}>
        <li>{office.telephone}</li>
        {renderWebsiteLink()}
      </ul>
    </div>
  );
};

export { Office };
